import React from 'react'
import { numberWithCommas } from '../../utils/customFunction'
import moment from 'moment'
import { Col, Row } from 'reactstrap'
import { useSelector } from 'react-redux'
import { IoAddCircle } from 'react-icons/io5'
import { AiFillMinusCircle } from 'react-icons/ai'

function MarketPortfolioCard(
    {
        data,
        itemsToShow = "",
        getImageSrc = "",
        setModalFlag = "",
        screen = "",
    }:
        {
            data?: any
            itemsToShow?: any
            getImageSrc?: any
            setModalFlag?: any
            screen?: any
        }
) {
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    return (
        <Row className='pt-3'>
            {data?.map((item, index) => {
                const diffValReturn: any = (Number(item?.marketData?.market_value || 0) - Number(item?.marketData?.total_amount || 0))
                const ReturnValInPercentage: any = Number(item?.marketData?.total_amount) == 0 ? 0 : ((Number(diffValReturn) / Number(item?.marketData?.total_amount)) * 100)?.toFixed(2)

                const avgUnitCost: any = Number(item?.marketData?.average_cost_per_unit || 0)?.toFixed(2)
                const totalCost: any = Number(item?.marketData?.total_amount || 0)?.toFixed(2)

                return (
                    <Col key={index} lg="4" xl="2" md="4" className={`mb-5 ${screen <= 500 ? "pb-3 border-bottom" : ""}`}>
                        <div
                            style={{
                                rowGap: "10px",
                                borderRadius: "15px",
                                border: "1px solid #1d8cf8 "
                            }}
                            className='d-flex flex-column align-items-center text-center py-2 shadow'>
                            <img
                                src={getImageSrc(item?.marketData?.symbol)}
                                width={50}
                                height={50}
                                style={{
                                    objectFit: "contain",
                                    objectPosition: "center"
                                }}
                            />
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column w-100'>
                                <p
                                    style={{ fontWeight: 600 }}
                                    data-toggle="tooltip" data-placement="top" title={item?.marketData?.code}
                                    className='mb-0 text-primary table_heading_large'>{item?.marketData?.code}</p>
                                <small
                                    style={{ whiteSpace: "break-spaces" }}
                                    className='text-info'>{item?.marketData?.name}</small>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Next Coupon
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 table_heading_large text-primary'>
                                    {moment(item?.marketData?.issue_date)?.format("DD-MMM-YYYY")}
                                </p>

                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Days to Coupon
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 table_heading_large text-primary'>
                                    {
                                        item?.marketData?.coupon_days || 0
                                    }
                                </p>

                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Units
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 table_heading_large text-primary'>
                                    {
                                        numberWithCommas(item?.marketData?.units || 0)
                                    }
                                </p>

                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Avg Unit Cost
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 text-primary table_heading_large'>
                                    <small
                                        className='xSmall'
                                    >
                                        Rs.
                                    </small>
                                    {
                                        numberWithCommas(avgUnitCost?.toString()?.includes(".") ?
                                            avgUnitCost?.toString()?.split(".")[0] :
                                            avgUnitCost || 0)
                                    }
                                    <small className='xSmall'>
                                        .{
                                            avgUnitCost?.toString()?.includes(".") ?
                                                avgUnitCost?.toString()?.split(".")[1] :
                                                "00"
                                        }
                                    </small></p>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Total Cost
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 text-primary table_heading_large'>
                                    <small
                                        className='xSmall'
                                    >
                                        Rs.
                                    </small>
                                    {
                                        numberWithCommas(totalCost?.toString()?.includes(".") ?
                                            totalCost?.toString()?.split(".")[0] :
                                            totalCost || 0)
                                    }
                                    <small className='xSmall'>
                                        .{
                                            totalCost?.toString()?.includes(".") ?
                                                totalCost?.toString()?.split(".")[1] :
                                                "00"
                                        }
                                    </small></p>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Market Value
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 text-primary table_heading_large'>
                                    <small
                                        className='xSmall'
                                    >
                                        Rs.
                                    </small>
                                    {
                                        numberWithCommas(item?.marketData?.market_value?.toString()?.includes(".") ?
                                            item?.marketData?.market_value?.toString()?.split(".")[0] :
                                            item?.marketData?.market_value || 0)
                                    }
                                    <small className='xSmall'>
                                        .{
                                            item?.marketData?.market_value?.toString()?.includes(".") ?
                                                item?.marketData?.market_value?.toString()?.split(".")[1] :
                                                "00"
                                        }
                                    </small></p>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Market Rate/Unit
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 text-primary table_heading_large'>
                                    <small
                                        className='xSmall'
                                    >
                                        Rs.
                                    </small>
                                    {
                                        numberWithCommas(item?.marketData?.market_rate_per_unit?.toString()?.includes(".") ?
                                            item?.marketData?.market_rate_per_unit?.toString()?.split(".")[0] :
                                            item?.marketData?.market_rate_per_unit || 0)
                                    }
                                    <small className='xSmall'>
                                        .{
                                            item?.marketData?.market_rate_per_unit?.toString()?.includes(".") ?
                                                item?.marketData?.market_rate_per_unit?.toString()?.split(".")[1] :
                                                "00"
                                        }
                                    </small></p>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Return (Profit/Loss)
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces",
                                        color: Number(diffValReturn) > 0 ?
                                            "#05bd64" :
                                            Number(diffValReturn) < 0 ?
                                                "#de4f45" :
                                                "#7ac6e1"
                                    }}
                                    className='mb-0 table_heading_large'>
                                    <small
                                        className='xSmall'
                                    >
                                        Rs.
                                    </small>
                                    {
                                        numberWithCommas(Number(diffValReturn)?.toFixed(0) || 0)
                                    }
                                    <small className='xSmall'>
                                        {" "}{
                                            diffValReturn?.toString()?.includes("-") ? "Loss" : "Profit"
                                        }
                                    </small></p>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Return %
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces",
                                        color: Number(ReturnValInPercentage) > 0 ?
                                            "#05bd64" :
                                            Number(ReturnValInPercentage) < 0 ?
                                                "#de4f45" :
                                                "#7ac6e1"
                                    }}
                                    className='mb-0 table_heading_large'>
                                    <small
                                        className='xSmall'
                                    >
                                        Rs.
                                    </small>
                                    {
                                        ReturnValInPercentage
                                    }
                                    <small className='xSmall'>
                                        %
                                    </small></p>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Unredeemed Amount
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 table_heading_large text-primary'>
                                    {numberWithCommas(item?.marketData?.unredeem_value)}
                                </p>
                            </div>
                            <div
                                style={{ lineHeight: "normal" }}
                                className='d-flex flex-column align-items-center w-100'>
                                <small
                                    style={{ opacity: "0.4" }}
                                    className={`smallTagColor-${theme}`}>
                                    Remaining Days
                                </small>
                                <p
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "break-spaces"
                                    }}
                                    className='mb-0 table_heading_large text-primary'>
                                    {
                                        numberWithCommas(moment(item?.marketData?.maturity_date).diff(moment(), 'days') || 0)
                                    }
                                </p>
                            </div>

                            <div className='d-flex flex-column align-items-center mx-3 mt-1'>
                                <small
                                    style={{
                                        opacity: "0.4"
                                    }}
                                    className={`smallTagColor-${theme}`}
                                >
                                    Action
                                </small>
                                <div className={`d-flex align-items-center `}>
                                    <div className='d-flex flex-column mr-0'>
                                        <div
                                            style={{
                                                maxWidth: "93px",
                                                border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                borderRadius: "18px"
                                            }}
                                            className='position-relative text-left mb-1 pl-4'
                                        >
                                            Maturity
                                            <IoAddCircle
                                                onClick={() => {
                                                    setModalFlag("Maturity")
                                                }}
                                                className='text-info'
                                                style={{
                                                    position: "absolute",
                                                    left: "-9px",
                                                    top: "-2px",
                                                    width: "30px",
                                                    height: "30px",
                                                    cursor: "pointer"
                                                }}
                                            />

                                        </div>
                                        <div
                                            style={{
                                                maxWidth: "93px",
                                                border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                borderRadius: "18px"
                                            }}
                                            className='position-relative text-left mb-1 pl-4'
                                        >
                                            Sell
                                            <AiFillMinusCircle
                                                onClick={() => {
                                                    setModalFlag("Sell")
                                                }}
                                                className='text-primary'
                                                style={{
                                                    position: "absolute",
                                                    left: "-9px",
                                                    top: "-2px",
                                                    width: "30px",
                                                    height: "30px",
                                                    cursor: "pointer"
                                                }}
                                            />

                                        </div>
                                        <div
                                            style={{
                                                maxWidth: "93px",
                                                border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                borderRadius: "18px"
                                            }}
                                            className='position-relative text-left mb-1 pl-4'
                                        >
                                            Coupon
                                            <IoAddCircle
                                                onClick={() => {
                                                    setModalFlag("Coupon")
                                                }}
                                                className='text-info'
                                                style={{
                                                    position: "absolute",
                                                    left: "-9px",
                                                    top: "-2px",
                                                    width: "30px",
                                                    height: "30px",
                                                    cursor: "pointer"
                                                }}
                                            />

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </Col>
                )
            })}
        </Row>
    )
}

export default MarketPortfolioCard